var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02158 20.0141C1.55441 20.0141 1.17214 19.6319 1.17214 19.1647L1.172 7.82405C1.172 7.35688 1.55427 6.97461 2.02144 6.97461C2.48861 6.97461 2.87088 7.35688 2.87088 7.82405V19.2073C2.87102 19.6321 2.48876 20.0144 2.02159 20.0144L2.02158 20.0141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9915 20.0141C17.5243 20.0141 17.142 19.6319 17.142 19.1647V7.82405C17.142 7.35688 17.5243 6.97461 17.9915 6.97461C18.4587 6.97461 18.841 7.35688 18.841 7.82405V19.2073C18.8411 19.6321 18.4588 20.0144 17.9915 20.0144V20.0141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1385 9.18349C18.9686 9.18349 18.7562 9.14097 18.6288 9.01355L10.0066 1.96267L1.38447 9.01355C1.04472 9.31091 0.492506 9.26839 0.195137 8.88612C-0.102232 8.54638 -0.0597094 7.99416 0.32256 7.69679L9.49702 0.221408C9.79439 -0.0334382 10.2616 -0.0334382 10.5589 0.221408L19.6908 7.69679C20.0305 7.99416 20.1156 8.50385 19.8182 8.88612C19.6483 9.09845 19.3934 9.18349 19.1386 9.18349H19.1385Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39295 20.0143H6.22676C5.75959 20.0143 5.37732 19.6321 5.37732 19.1649C5.37732 18.6977 5.75959 18.3154 6.22676 18.3154H8.39295C8.86012 18.3154 9.24239 18.6977 9.24239 19.1649C9.24239 19.6321 8.86012 20.0143 8.39295 20.0143Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39295 16.4889H6.22676C5.75959 16.4889 5.37732 16.1066 5.37732 15.6395C5.37732 15.1723 5.75959 14.79 6.22676 14.79H8.39295C8.86012 14.79 9.24239 15.1723 9.24239 15.6395C9.24239 16.1492 8.86012 16.4889 8.39295 16.4889Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7867 20.0143H11.6204C11.1533 20.0143 10.771 19.6321 10.771 19.1649C10.771 18.6977 11.1533 18.3154 11.6204 18.3154H13.7867C14.2538 18.3154 14.6361 18.6977 14.6361 19.1649C14.6362 19.6321 14.254 20.0143 13.7867 20.0143Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7867 16.4889H11.6204C11.1533 16.4889 10.771 16.1066 10.771 15.6395C10.771 15.1723 11.1533 14.79 11.6204 14.79H13.7867C14.2538 14.79 14.6361 15.1723 14.6361 15.6395C14.6362 16.1492 14.254 16.4889 13.7867 16.4889Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1107 13.3883H8.94453C8.47736 13.3883 8.09509 13.0061 8.09509 12.5389C8.09509 12.0717 8.47736 11.6895 8.94453 11.6895H11.1107C11.5779 11.6895 11.9602 12.0717 11.9602 12.5389C11.9603 13.0061 11.5355 13.3883 11.1107 13.3883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverInventory);
export default __webpack_public_path__ + "static/media/hover-Inventory.74a41f416d5faf94d2111c5684a6db05.svg";
export { ForwardRef as ReactComponent };